import styled from '@emotion/styled';

import { customPalette } from '../../../styles/theme';

export const SidebarContainer = styled.div`
  font-size: 13px;
  position: fixed;
  width: 100%;

  @media (min-width: 1200px) {
    width: 300px;
  }

  @media (min-width: 1536px) {
    width: 300px;
  }

  aside {
    border: none;
    width: 100%;
  }

  ul {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
  }

  .ps-menu-root {
    background: ${customPalette.accent.main};
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0;
  }

  .ps-menu-label {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    font-family: 'Nunito', sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 21.6px;
    letter-spacing: 0.15px;

    &.active {
      color: ${customPalette.accent.white} !important;
    }

    &:hover {
      color: ${customPalette.accent.defaultGreen};
    }
  }

  .ps-menuitem-root {
    background: ${customPalette.accent.main};

    a {
      height: 45px;
    }
  }

  .ps-menu-button {
    margin: 16px 0;
    padding: 0 24px !important;

    &:hover {
      background: ${customPalette.accent.main} !important;
    }

    &:hover .ps-menu-label {
      color: ${customPalette.accent.defaultGreen} !important;
    }

    &:hover svg path {
      stroke: ${customPalette.accent.white} !important;
    }

    &.active {
      background: ${customPalette.accent.defaultGreen} !important;
      color: ${customPalette.accent.white} !important;
      border-radius: 8px;
    }

    &.active .ps-menu-label {
      color: ${customPalette.accent.white} !important;
    }

    &.active svg path {
      stroke: ${customPalette.accent.white} !important;
    }

    &.active:hover {
      background: ${customPalette.accent.defaultGreen} !important;
      color: ${customPalette.accent.white} !important;
    }

    &.active:hover .ps-menu-label {
      color: ${customPalette.accent.white} !important;
    }

    &.active:hover svg path {
      stroke: ${customPalette.accent.white} !important;
    }
  }
`;

export const StyledLogo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 24px;
  gap: 10px;
`;

export const LogoText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AppTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${customPalette.accent.white};
`;

export const Subtitle = styled.span`
  font-size: 12px;
  color: ${customPalette.accent.white};
`;

export const BottomLinks = styled.div`
  margin-top: auto;
  width: 100%;
  background: ${customPalette.accent.main};
`;
